import type { CityConfig } from "../city-template/types";

export const laurelConfig: CityConfig = {
  city: "Laurel",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "laurel",
  route: "/cities/laurel",
  title: "Emergency Passport Laurel, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Laurel, Maryland — as fast as 24 hours. Fast passport renewal and new passport applications for Laurel, Beltsville, Columbia, and Fort Meade. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Laurel, MD",
  heroSubtitle: "Laurel residents — from Fort Meade military families to Howard County commuters — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving Prince George's and Howard County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Historic%20Main%20Street%20Laurel%20Maryland%20with%20charming%20brick%20storefronts%2C%20historic%20train%20station%2C%20tree-lined%20boulevard%2C%20American%20flags%2C%20warm%20afternoon%20sunlight%2C%20professional%20small%20town%20photography%2C%20no%20visible%20text%20or%20people%2C%20red%20brick%20architecture%20with%20green%20awnings%20and%20flower%20planters&width=1800&height=700&seq=laurel-hero-001&orientation=landscape",
  heroImageAlt: "Historic Main Street view of Laurel Maryland with charming brick storefronts and train station",
  geoPosition: "39.0993;-76.8483",
  geoPlacename: "Laurel, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 25–35 minutes from Laurel via I-95 S",
  },
  nearbyCitiesZips: [
    { name: "Laurel", zips: "20707, 20708, 20709, 20723, 20725, 20726" },
    { name: "Beltsville", zips: "20704, 20705" },
    { name: "Columbia", zips: "21044, 21045, 21046, 21075" },
    { name: "Fort Meade", zips: "20755" },
    { name: "Jessup", zips: "20794" },
    { name: "Savage", zips: "20763" },
    { name: "Scaggsville", zips: "20723" },
    { name: "Burtonsville", zips: "20866" },
    { name: "Elkridge", zips: "21075" },
    { name: "Hanover", zips: "21076" },
    { name: "Greenbelt", zips: "20768, 20770, 20771" },
    { name: "College Park", zips: "20740, 20741, 20742" },
    { name: "Bowie", zips: "20715, 20716, 20717, 20718, 20719, 20720, 20721" },
    { name: "Ellicott City", zips: "21041, 21042, 21043" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Laurel and Fort Meade departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-shield-star-line", title: "Military Base Proximity", desc: "Serving Fort Meade military families and defense contractors" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in Columbia, MD", route: "/cities/columbia" },
    { name: "Emergency passport help in Ellicott City, MD", route: "/cities/ellicott-city" },
    { name: "Urgent passport services in Greenbelt, MD", route: "/cities/greenbelt" },
    { name: "Maryland passport services overview", route: "/states/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Laurel, Maryland remotely via secure registered courier. We do not have a walk-in office in Laurel — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Laurel travelers without the drive to downtown DC.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, MD 20814",
  fpcOfficeDistance: "Serving Laurel, Beltsville, Columbia, Fort Meade, and greater Prince George's and Howard County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout the Laurel area and greater Prince George's and Howard County. From the historic Main Street district near the B&O Railroad Museum to the modern suburban neighborhoods, from the military community at Fort Meade to the tech corridor along Route 1 — we serve all of Laurel's diverse communities.",
  nearbyCitiesIntro: "We serve Laurel and nearby communities including Beltsville, Columbia, Fort Meade, Jessup, Savage, Scaggsville, Burtonsville, Elkridge, Hanover, Greenbelt, College Park, Bowie, and Ellicott City.",
  howItWorksIntro: "Most Laurel travelers complete everything online and ship documents overnight. No need to drive 25–35 minutes to downtown DC or navigate I-95 during rush hour.",
  mistakesIntro: "Laurel is a crossroads community with military families, commuters, and Howard County residents. Here are the most common passport mistakes we see from Laurel travelers.",
  testimonialsIntro: "Laurel travelers — from Fort Meade families to commuters to Howard County residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Laurel, MD? Here are the most common ones we hear from Prince George's and Howard County travelers.",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (MD Vital Statistics)", url: "https://health.maryland.gov/vsa/", desc: "Maryland Department of Health — Vital Statistics Administration for birth and death certificates statewide" },
    { label: "Marriage Licenses (Prince George's County Clerk)", url: "https://www.princegeorgescountymd.gov/366/Clerk-of-the-Circuit-Court", desc: "Prince George's County Circuit Court Clerk for Laurel area" },
    { label: "Divorce Decrees (Prince George's County Circuit Court)", url: "https://www.princegeorgescountymd.gov/366/Clerk-of-the-Circuit-Court", desc: "Prince George's County Circuit Court for divorce decree records" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Maryland vital records online via VitalChek" },
  ],
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for military and defense travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 25–35 min to downtown DC", "Full day commitment — I-95 traffic can be brutal"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Laurel travelers with immediate departure needs — as fast as 24 hours. Perfect for military deployments, defense contractor travel, and last-minute trips.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Military and defense travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Laurel adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Laurel address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Laurel residents and families — including military spouses and new families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Laurel residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Laurel families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Laurel residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Laurel MD", description: "Urgent passport processing for Laurel Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Laurel MD", description: "Fast passport renewal for Laurel Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Laurel MD", description: "New passport application services for Laurel Maryland residents applying for their first passport." },
    { name: "Child Passport Laurel MD", description: "Minor passport services for Laurel Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "Sgt. James R.",
      location: "Fort Meade, MD",
      rating: 5,
      text: "Last-minute PCS required updated passport. They understood military timelines and had it in my hands within 40 hours. Professional service that knows the urgency of defense travel.",
      service: "Emergency Passport",
    },
    {
      name: "Maria T.",
      location: "Laurel, MD",
      rating: 5,
      text: "Family trip to Jamaica with 10 days notice. Three passports processed in under a week. We shipped from the Laurel UPS Store and everything arrived on time.",
      service: "Family Passport Bundle",
    },
    {
      name: "David H.",
      location: "Columbia, MD",
      rating: 5,
      text: "Business trip to London with 6 days notice. Fast Passport Center had my renewed passport ready in 2 days. No driving to DC — everything shipped overnight.",
      service: "Passport Renewal",
    },
    {
      name: "Karen L.",
      location: "Beltsville, MD",
      rating: 5,
      text: "Study abroad trip to Spain with 8 days notice. Fast Passport Center handled my first-time passport application and had it ready in 4 days. Amazing service for students.",
      service: "First-Time Passport",
    },
  ],
  facilities: [
    {
      id: "laurel-1",
      name: "Laurel Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "450 Main St",
      city: "Laurel",
      state: "MD",
      zip: "20707",
      phone: "(301) 776-5000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Laurel, on historic Main Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Laurel acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient for downtown and historic district residents.",
      icon: "ri-mail-line",
    },
    {
      id: "laurel-2",
      name: "Beltsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10901 Baltimore Ave",
      city: "Beltsville",
      state: "MD",
      zip: "20705",
      phone: "(301) 937-7100",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Beltsville, approximately 3 miles west of Laurel",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Beltsville and western Prince George's County residents. Good alternative when Laurel appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "laurel-3",
      name: "Columbia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8800 Centre Park Dr",
      city: "Columbia",
      state: "MD",
      zip: "21045",
      phone: "(410) 715-0300",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Columbia, approximately 8 miles northwest of Laurel",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Columbia and Howard County residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "laurel-4",
      name: "Bowie Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1300 8th St",
      city: "Bowie",
      state: "MD",
      zip: "20715",
      phone: "(301) 262-9000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Bowie, approximately 6 miles south of Laurel",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Bowie and southern Prince George's County residents. Good alternative for Fort Meade families.",
      icon: "ri-mail-line",
    },
    {
      id: "laurel-5",
      name: "Howard County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "8360 Court Ave",
      city: "Ellicott City",
      state: "MD",
      zip: "21043",
      phone: "(410) 313-2200",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Ellicott City, approximately 12 miles northwest of Laurel",
      website: "https://www.howardcountymd.gov/",
      websiteLabel: "Howard County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office locations. Serving Howard County and western Prince George's County residents.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 25–35 min drive to downtown DC", fpc: "No — ship from Laurel" },
    { feature: "Military Travel Support", agency: "No flexibility for PCS needs", fpc: "Yes — we handle military cases" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Laurel's busy military families and commuters often discover passport needs just weeks before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services in Laurel sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Laurel and Prince George's County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "Laurel Post Office appointments fill up fast, especially during summer and holiday travel seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over.",
    },
    {
      icon: "ri-time-line",
      title: "Underestimating Routine Processing Time",
      description: "Laurel residents often assume 4–6 weeks is enough. Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Laurel, Beltsville, or Columbia." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location near Main St or Route 1." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Laurel address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Laurel, MD?", a: "Fast Passport Center offers emergency passport processing in Laurel, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency (25–35 minutes from Laurel) — without you needing to make the drive or fight I-95 traffic." },
    { q: "Does Laurel have its own passport agency?", a: "No — neither Laurel nor the state of Maryland has a regional passport agency. The closest facility is the Washington DC Passport Agency, approximately 25–35 minutes from Laurel via I-95 S. Fast Passport Center's courier service means Laurel residents never need to make that drive." },
    { q: "Can I get expedited passport services if I live in Columbia or Beltsville?", a: "Absolutely. Fast Passport Center serves all of the Laurel area including Columbia, Beltsville, Fort Meade, Jessup, Savage, and Greenbelt. We also serve Bowie and Ellicott City residents. Our service works the same way — complete your application online, ship your documents, and we handle the rest." },
    { q: "How much does an expedited passport cost in Laurel, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Laurel travelers use for international flights?", a: "Most Laurel residents fly internationally through Baltimore-Washington International (BWI), approximately 15–20 minutes northeast via I-295 and MD-295. Dulles International (IAD) is 35–45 minutes west. Reagan National (DCA) is 25–35 minutes south. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in Laurel?", a: "Yes. Fast Passport Center handles multi-passport cases for families in Laurel, Columbia, Beltsville, and surrounding areas. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to Laurel?", a: "The Laurel Post Office at 450 Main St is the primary downtown acceptance facility. The Beltsville Post Office at 10901 Baltimore Ave serves western residents. The Columbia Post Office at 8800 Centre Park Dr serves Howard County residents. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. Laurel residents should plan ahead, especially for military deployments and family travel." },
  ],
  photoLocations: [
    { name: "Walgreens — Laurel", address: "14201 Baltimore Ave, Laurel, MD 20707", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Laurel", address: "13600 Baltimore Ave, Laurel, MD 20707", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Laurel", address: "337 Main St, Laurel, MD 20707", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Columbia", address: "6430 Dobbin Center Way, Columbia, MD 21045", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "MVA — Beltsville", address: "11701 Baltimore Ave, Beltsville, MD 20705", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Prince George's County and Howard County. REAL ID processing available.", featured: true },
    { name: "MVA — Ellicott City", address: "6310 Hillside Ct, Columbia, MD 21046", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Howard County and western Prince George's County. Full service including REAL ID.", featured: false },
  ],
  airports: [
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "15–20 minutes from Laurel via I-295 and MD-295",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Primary airport for Laurel travelers. Direct international flights and major domestic connections. Southwest Airlines hub.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: true,
    },
    {
      code: "DCA",
      name: "Reagan National (Washington DC)",
      distance: "25–35 minutes from Laurel via I-95 S",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Alternative for domestic connections. Limited international flights but excellent for connecting to major hubs.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Flight Info",
      featured: false,
    },
    {
      code: "IAD",
      name: "Dulles International",
      distance: "35–45 minutes from Laurel via I-95 S and I-495 W",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Alternative for international flights. Direct flights to London, Frankfurt, and major European hubs.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: false,
    },
  ],
};